export default function AboutSection() {
  return (
    <section id="about" className="w-full py-10 md:py-14 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1200px] mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-xl md:text-3xl font-bold text-foreground-950 mb-3">关于我们</h2>
          <p className="text-foreground-600 text-sm md:text-base">了解51吃瓜网址的故事与使命</p>
        </div>

        <div className="max-w-3xl mx-auto bg-background-50 border border-background-200/60 rounded-2xl p-6 md:p-8 lg:p-10">
          <div className="prose prose-sm max-w-none">
            <p className="text-foreground-700 text-sm md:text-base leading-relaxed mb-4">
              51吃瓜网址创立于娱乐资讯高速发展的时代，致力于为全网吃瓜群众打造一个便捷、高效、安全的一站式导航平台。
              我们深知，在纷繁复杂的网络世界中，找到一个稳定可靠的信息入口有多么重要。
            </p>
            <p className="text-foreground-700 text-sm md:text-base leading-relaxed mb-4">
              本站聚合51吃瓜网址新入口、51吃瓜官网全网最新等官方直达通道，实时同步51吃瓜网站入口的最新动态与防走失域名。
              从娱乐圈最新爆料到明星动态追踪，从热播剧综吐槽到体育科技圈八卦，我们以最快的速度、最全的覆盖，为每一位用户提供优质的吃瓜导航体验。
            </p>
            <p className="text-foreground-700 text-sm md:text-base leading-relaxed mb-4">
              本站拥有多线路防屏蔽机制与每日更新的备用域名系统，无论网络环境如何变化，用户都能通过51吃瓜网址一键访问不迷路。
              我们坚持免费开放、无需注册的运营理念，只为让吃瓜变得更加简单快乐。
            </p>
            <p className="text-foreground-700 text-sm md:text-base leading-relaxed">
              未来，51吃瓜网址将持续优化内容聚合算法，拓展更多主题频道，提升移动端访问体验。
              感谢每一位用户的支持与信任，你们的每一次访问都是我们不断进步的动力。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}